/**
 * Champ « Alignement horizontal » — position d'une box dans sa colonne de
 * section ; appliqué par ProposalBoxAlign (pendant de puckVerticalAlignField).
 */
export function puckHorizontalAlignField(label = 'Alignement horizontal') {
  return {
    type: 'select',
    label,
    options: [
      { label: 'Gauche', value: 'left' },
      { label: 'Centre', value: 'center' },
      { label: 'Droite', value: 'right' },
    ],
  };
}
